module.exports = __webpack_public_path__ + "static/8-19ebe9497fd89baaae1902e4192e70b2.jpg";